import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row py-2" }
const _hoisted_2 = { class: "col-3 pt-2 ps-0" }
const _hoisted_3 = { class: "list-unstyled settings-nav" }
const _hoisted_4 = { class: "col-9" }

import { ref } from "vue";
    import AccountInfo from "@/guiide/components/userSettings/AccountInfo.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'UserSettingsEditor',
  emits: ['exit'],
  setup(__props, { emit: __emit }) {

    const emit = __emit;
    const selectedTabIndex = ref(0);

    function onCloseClicked() {
        emit('exit');
    }

    function onTabClick(index: number) {
        selectedTabIndex.value = index;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", {
            class: _normalizeClass(["mt-2", {
                        'active': selectedTabIndex.value == 0,
                        'settings-link': selectedTabIndex.value != 0
                    }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onTabClick(0)))
          }, " Account info ", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(AccountInfo, null, null, 512), [
          [_vShow, selectedTabIndex.value == 0]
        ])
      ])
    ]),
    _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-4 pt-3 border-top" }, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-link text-dark text-decoration-none",
          "aria-label": "Close",
          onClick: onCloseClicked
        }, " Exit ")
      ])
    ])
  ], 64))
}
}

})